import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CardTypes } from '../../utils/enums';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { isPortrait } from '../../utils/size';
import { isLongText } from '../../components/Shared/commonFunctions';
import { getActionCompletedTime } from '../../utils/actionTiming';
import {
    relevantRepresentatives,
    joinEnglish
} from '../../utils/localRepresentative/parser';

import {
    onFindYourRep,
    hideFindRepPopup,
    loadLocalRep,
    goToFindLocalRep,
    selectAction
} from '../LocalRep/actions';

import {
    onGoToNextCard,
    onGoToNextActionInsideCard,
    setOverlayPartnerVisible
} from '../Widget/actions';

import { initTweet, onCompleteTweet } from '../Tweet/actions';
import getTwitterShareUrl from '../../utils/tweet/tweetShare';

import LocalRepAction from '../../components/LocalRep/LocalRepAction';
import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';

import {
    SingleAction,
    parseSingleActionProps
} from '../SingleAction/SingleActionDetails';

class TweetStart extends SingleAction {
    tweetAndAdvanceToNextCard = activeAction => {
        window.open(
            getTwitterShareUrl(
                activeAction.text,
                this.props.localRepTwitterMention,
                this.props.localRepPostalCode,
                this.props.partnerName,
                this.props.publisherName,
                this.props.articleUrl,
                false
            ),
            'popup',
            'height=350,width=600'
        );

        this.props.initTweet(this.props.apiRequestData, this.props.actionIdentifier);

        this.props.onCompleteTweet(
            this.props.apiRequestData,
            this.props.actionCompletedTime(),
            this.props.actionIdentifier,
            this.props.feedbackText,
            this.props.feedbackTitle,
            this.props.useLocalRepresentative,
            this.props.localRepresentativeState
        );

        if (this.props.nextAction) {
            return this.props.onGoToNextCard(
                this.props.nextAction.identifier,
                this.props.nextAction.type,
                this.props.nextCard.type === CardTypes.multipleActions ||
                    this.props.nextCard.type === CardTypes.multiDonation,
                this.props.nextCard.type === CardTypes.targetedMultiAction,
                this.props.nextAction.skipFrontCard
            );
        }
    };

    buttonComponent() {
        return (
            <AutoScalingButtonSet>
                {this.props.actions.map(a => (
                    <LocalRepAction
                        isLongText={
                            !isPortrait() &&
                            isLongText(this.props.cardTitle, 40) &&
                            isLongText(this.props.cardDescription, 90)
                        }
                        action={a}
                        text={a.label}
                        key={a.identifier}
                        onClick={() => {
                            if (
                                this.props.activeAction.type === 'tweet' &&
                                (this.props.localRepFound || !a.useLocalRepresentative)
                            ) {
                                this.tweetAndAdvanceToNextCard(this.props.activeAction);
                            } else {
                                if (
                                    this.props.localRepFound ||
                                    !a.useLocalRepresentative
                                ) {
                                    this.props.selectAction(a.identifier);
                                    return this.props.onGoToNextActionInsideCard(
                                        a.identifier,
                                        a.type,
                                        true
                                    );
                                } else {
                                    this.props.selectAction(a.identifier);
                                    this.props.goToFindLocalRep(a.identifier, a.type);
                                }
                            }
                        }}
                    />
                ))}
            </AutoScalingButtonSet>
        );
    }
}
TweetStart.propTypes = {
    ...SingleAction.propTypes,
    apiRequestData: PropTypes.object.isRequired,
    localRepTwitterMention: PropTypes.string,
    localRepPostalCode: PropTypes.string,
    partnerName: PropTypes.string,
    publisherName: PropTypes.string,
    articleUrl: PropTypes.string,
    actionIdentifier: PropTypes.string.isRequired,
    feedbackText: PropTypes.string.isRequired,
    feedbackTitle: PropTypes.string.isRequired,
    localRepresentativeState: PropTypes.number,
    onCompleteTweet: PropTypes.func.isRequired,
    initTweet: PropTypes.func.isRequired,
    actionCompletedTime: PropTypes.func.isRequired,
    activeAction: PropTypes.object.isRequired,
    nextAction: PropTypes.object.isRequired,
    useLocalRepresentative: PropTypes.bool.isRequired,
    nextCard: PropTypes.object.isRequired,
    cardTitle: PropTypes.string.isRequired,
    cardDescription: PropTypes.string.isRequired
};

export default connect(
    state => {
        const reps = state.localRep.localRepData
            ? relevantRepresentatives(
                  state.widget.activeAction.localRepresentativeState,
                  state.localRep.localRepData.representative
              )
            : [];
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            ...parseSingleActionProps(state),
            activeAction: state.widget.activeAction,
            nextAction,
            nextCard: nextAction ? state.widget.cards[nextAction.order - 1] : null,
            actionCompletedTime: getActionCompletedTime(state, 'tweet'),
            apiRequestData: state.widget.apiRequestData,
            localRepTwitterMention: joinEnglish(
                reps.map(rep => {
                    if (rep.twitterMention && rep.twitterMention.length > 0) {
                        return '@' + rep.twitterMention;
                    }
                    return rep.fullName;
                })
            ),
            localRepPostalCode: state.localRep.localRepData.postalCode,
            partnerName:
                state.widget.activeAction.partner !== undefined
                    ? state.widget.activeAction.partner.twitterMention !== undefined
                        ? '@' + state.widget.activeAction.partner.twitterMention
                        : state.widget.activeAction.partner.name
                    : 'Speakable',
            publisherName:
                state.widget.twitterMention !== undefined
                    ? '@' + state.widget.twitterMention
                    : state.widget.publisherName,
            articleUrl: state.widget.articleUrl,
            actionIdentifier: state.widget.activeAction.identifier,
            feedbackText:
                state.widget.activeAction.thankYouText || 'Make your voice heard!',
            feedbackTitle: state.widget.activeAction.thankYouTitle || 'Speak Up',
            localRepresentativeState: state.widget.activeAction.localRepresentativeState
        };
    },
    {
        onFindYourRep,
        hideFindRepPopup,
        loadLocalRep,
        onGoToNextCard,
        onGoToNextActionInsideCard,
        goToFindLocalRep,
        setOverlayPartnerVisible,
        selectAction,
        initTweet,
        onCompleteTweet
    }
)(TweetStart);



// WEBPACK FOOTER //
// ./src/containers/Tweet/TweetStart.jsx